<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Gérer des informations" index-progression-courante="3" index-progression-secondaire="5"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="organiseractivite"/>
    <footer-applis ecran-precedent="mobiliserraisonnements" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'gererinformations',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'énumère les supports d’informations utiles pour réaliser une opération donnée'
      }, {
        niveau: 2,
        valeur: 'Identifie les informations manquantes pour réaliser une opération'
      }, {
        niveau: 3,
        valeur: 'Je hiérarchise les informations présentes dans la situation et mobilise une méthode pour les traiter'
      }, {
        niveau: 4,
        valeur: 'J\'analyse les enjeux des informations pour les utiliser et les faire circuler'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.gererinformations = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('organiseractivite');
    }
  }
}
</script>
